import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';

@Component({
  selector: 'app-reset-password-holder',
  templateUrl: './reset-password-holder.component.html',
  styleUrls: ['./reset-password-holder.component.scss']
})
export class ResetPasswordHolderComponent implements OnInit {

  constructor(
    public dialog: MatDialog
  ) { }


  ngAfterViewInit(): void {
    const dialogRef = this.dialog.open(ResetPasswordComponent, {
      width: "450px",
      disableClose: false,
    })

    dialogRef.afterClosed().subscribe(v=>{
     if(!dialogRef.componentInstance.afterRegClose)
     {
          window.history.back();
      }
    
    })

  }

  ngOnInit() {
  }

}
